import qs from 'qs';
import client from './client';

const noticeUrl = '/api/v1/sys/board';

//대시보드 공지 리스트
export const getDashNotices = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${noticeUrl}/list/dashboard?${queryString}`);
}

//공지 리스트 가져오기
export const getNotices = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${noticeUrl}/list?${queryString}`);
}



//공지 추가
export const addNotice = (dataToSubmit) => {
  return client.post(`${noticeUrl}/info`, dataToSubmit);
};

//공지 정보
export const getNotice = (id) => client.get(`${noticeUrl}/info/${id}`);

export const editNotice = (id, dataToSubmit) => {
  return client.put(`${noticeUrl}/info/${id}`, dataToSubmit);
};

//공지 삭제
export const removeNotice = (id) => client.delete(`${noticeUrl}/info/${id}`);

//공지 첨부파일 리스트
//파일 가져오기 :fileTyp => tech, workUuid
export const getNoticeFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};
